import StatusPageLayout from "../../components/StatusPageLayout";

export const PageUnauthorized = () => (
  <StatusPageLayout
    // code="401"
    title="Unauthorized"
    message={`You must be logged in to view this page.\nPlease sign in and try again.`}
  />
);
